import {type ComponentProps} from 'react';
import {useNode} from '@craftjs/core';
import {classNames} from 'utils';
import {useEditorStyle} from 'hooks';
import ContentEditable from 'react-contenteditable';

interface IEditorContentParagraphProps extends ComponentProps<'p'> {
  text?: string;
  mobileStyle?: React.CSSProperties;
}

const EditorContentParagraph = ({text}: IEditorContentParagraphProps) => {
  const {
    connectors: {connect},
    actions: {setProp},
    selected,
    hovered,
  } = useNode(node => ({
    selected: node.events.selected,
    hovered: node.events.hovered,
  }));

  const {style} = useEditorStyle();

  return (
    <ContentEditable
      innerRef={connect}
      disabled
      style={style}
      html={text ?? ''}
      tagName="p"
      className={classNames(hovered ? 'shadow-[inset_0_0_0_2px_#34bb78]' : selected ? 'shadow-[inset_0_0_0_2px_#acbdd4]' : '')}
      onChange={e => {
        setProp((prop: IEditorContentParagraphProps) => (prop.text = e.target.value), 500);
      }}
    />
  );
};

EditorContentParagraph.craft = {
  displayName: 'Paragraph',
  custom: {
    icon: 'Bars3BottomLeftIcon',
  },
  props: {
    text: 'Text',
    style: {
      fontSize: '24px',
      textAlign: 'left',
      color: 'black',
      padding: '0 0 0 0',
      margin: '0 0 0 0',
    },
    mobileStyle: {},
  },
};

export default EditorContentParagraph;
